import React from "react";
import "../../styles/FormCard.css";

const FormSection = ({ title, children }) => {
  return (
    <div className="form-section">
      {title && <h3 className="form-section-title">{title}</h3>}
      <div className={title ? "form-section-content" : ""}>
        {children}
      </div>
    </div>
  );
};

export default FormSection;
